import React, { Component } from "react";
import { Form, Button, Spin, Tabs, Tag, message } from "antd";
import { parse, stringify } from "qs";
import { router } from "umi";
import { connect } from "dva";
import moment from "moment";
import Container from "../../../../../components/Container";
import FormCreate from "../../../../../components/FormCreate/index";
import SelectSupervise from "../components/SelectSuperviseModal";
import styles from "./index.less";

const { Item } = Form;
const { TabPane } = Tabs;
const {
  FormTitle,
  FormTextArea,
  FormRangePicker,
  SenderUser: SelectUser,
  FormSelect
} = FormCreate;

const projectTypeData = [
  {
    value: "1",
    label: "督政"
  },
  {
    value: "2",
    label: "督学"
  },
  {
    value: "3",
    label: "评估监测"
  }
];

@Form.create()
@connect(({ createProject }) => ({
  spinProps: createProject.spinProps,
  projectDetail: createProject.projectDetail,
  superviseList: createProject.superviseList,
  existedOrgIds: createProject.existedOrgIds,
  orgList: createProject.orgList,
  addProps: createProject.addProps,
  activeKey: createProject.activeKey
}))
class EditView extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location;
    const query = parse(search.split("?").pop()); // 换成utils里的GetQueryString
    const { currentProjectId, currentProjectName } = query;
    this.currentProjectId = currentProjectId;
    this.currentProjectName = currentProjectName;

    this.state = {
      processTypeMap: {
        "1": [
          {
            label: "人民政府履行教育职责督导评价",
            value: "1-1"
          },
          {
            label: "义务教育均衡发展监测",
            value: "1-2"
          }
        ],
        "2": [
          {
            label: "发展性评价",
            value: "2-1"
          }
        ],
        "3": [
          {
            label: "评估监测",
            value: "3-1"
          }
        ]
      },
      processTypeOption: [],
      currentProjectId,
      isEdit: false, // 编辑 或 新增
      // respondentOrgList: [],
      selectedNameList: [], // 选中的督查对象的名字
      selectedIdList: [], // 选中的督查对象的orgId
      selectedList: [],
      // userSelectId: "",
      principalUserSelectId: null,
      memberUserSelectId: null,
      type: "",
      isShowSelectSupervise: false
    };
  }

  componentDidMount() {
    const { currentProjectId } = this.state;
    let isEdit = false;
    if (currentProjectId) {
      // 编辑
      isEdit = true;
      this.getDetail();
    } else {
      // 新增
      isEdit = false;
    }
    this.setState({
      isEdit
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "createProject/reset"
    });
  }

  // 获取表单详情请求
  getDetail = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "createProject/fetchProjectDetail",
      payload: {
        projectId: currentProjectId
      },
      callback: this.handleGetProcessType
    });
  };

  // 当选择项目类型时设置相应的相应的项目流程
  handleTypeChange = val => {
    const { processTypeMap } = this.state;
    const { form } = this.props;
    const { setFieldsValue } = form;
    const processTypeOption = processTypeMap[val];
    this.setState(
      {
        processTypeOption
      },
      () => {
        setFieldsValue({
          processType: undefined
        });
      }
    );
  };

  // 获取详情初始值
  handleGetProcessType = () => {
    const { projectDetail } = this.props;
    const { selectedIdList, selectedNameList, processTypeMap } = this.state;

    const {
      projectType,
      principalUserSelectId,
      memberUserSelectId,
      respondentOrgList
    } = projectDetail;

    const processTypeOption = processTypeMap[projectType];

    if (respondentOrgList) {
      respondentOrgList.map(item => {
        selectedIdList.push(item.orgId);
        selectedNameList.push(item.orgName);
      });
    }
    this.setState({
      principalUserSelectId,
      memberUserSelectId,
      type: "edit",
      selectedIdList,
      selectedNameList,
      processTypeOption
    });
  };

  // 改变tab
  changeTab = activeKey => {
    const { dispatch } = this.props;
    dispatch({
      type: "createProject/save",
      payload: { activeKey }
    });
  };

  // 提交表单内容
  submitForm = () => {
    const {
      form: { validateFields }
    } = this.props;
    // const { principalUserSelectId, memberUserSelectId } = this.state;
    validateFields((err, values) => {
      if (!err) {
        this.fetchSubmit(values);
      } else {
        message.error("信息填写页必填项未填写完整");
      }
    });
  };

  // 发起表单内容的提交
  fetchSubmit = values => {
    const { isEdit, currentProjectId, selectedList } = this.state;
    const { dispatch } = this.props;
    const { time } = values;
    const startTime = Date.parse(new Date(time[0]));
    const endTime = Date.parse(new Date(time[1]));
    if (isEdit) {
      // 编辑接口
      dispatch({
        type: "createProject/fetchEditProject",
        payload: {
          ...values,
          startTime,
          endTime,
          projectId: currentProjectId,
          respondentOrgList: selectedList
        },
        callback: this.handleGoIndex
      });
    } else {
      // 新增接口
      dispatch({
        type: "createProject/fetchAddProject",
        payload: {
          ...values,
          startTime,
          endTime,
          respondentOrgList: selectedList
        },
        callback: this.handleGoIndex
      });
    }
  };

  handleCancel = () => {
    router.go(-1);
  };

  onCancel = () => {
    this.setState({
      isShowSelectSupervise: false
    });
  };

  handleGoIndex = () => {
    const { addProps } = this.props;
    const { projectId, projectName } = addProps;
    router.push(
      `/supervision/norm/project/overview?${stringify({
        currentProjectId: projectId || this.currentProjectId,
        currentProjectName: projectName || this.currentProjectName
      })}`
    );
  };

  // 显示选择督查对象显示列表
  handleShowSupervise = () => {
    this.setState(
      {
        isShowSelectSupervise: true
      },
      () => {
        this.handleGetSuperviseList();
      }
    );
  };

  // 获取督查对象列表
  handleGetSuperviseList = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "createProject/fetchGetSuperviseList",
      payload: {
        projectId: currentProjectId,
        param: ""
      }
    });
  };

  // 设置督查对象
  handleSetSupervise = (selectedList, selectedNameList) => {
    this.setState({
      selectedList,
      selectedNameList,
      isShowSelectSupervise: false
    });
  };

  handlePricipalFormDataChange = ({ selectSignature }) => {
    // console.log("TCL: EditView -> handleFormDataChange -> val", selectSignature)
    // const { formData: { receiveUserTemplate } } = val;
    this.setState({
      principalUserSelectId: selectSignature
    });
  };

  handleMemberFormDataChange = ({ selectSignature }) => {
    // console.log("TCL: EditView -> handleFormDataChange -> val", val)
    // const { formData: { receiveUserTemplate } } = val;
    this.setState({
      memberUserSelectId: selectSignature
    });
  };

  // 上一步
  preStep = () => {
    const { activeKey, dispatch } = this.props;
    dispatch({
      type: "createProject/save",
      payload: { activeKey: `${Number(activeKey) - 1}` }
    });
  };

  // 下一步
  nextStep = () => {
    const { activeKey, dispatch } = this.props;
    dispatch({
      type: "createProject/save",
      payload: { activeKey: `${Number(activeKey) + 1}` }
    });
  };

  // tab标题渲染
  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index
              ? "common-icon-style active-style"
              : "common-icon-style icon-style"
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  // 渲染底部按钮
  renderFooter = () => {
    const { activeKey } = this.props;
    let footerParams = {};
    if (activeKey === "1") {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          </>
        )
      };
    } else {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
            <Button type="primary" onClick={this.submitForm}>
              发布
            </Button>
          </>
        )
      };
    }
    return footerParams;
  };

  render() {
    const {
      selectedNameList,
      // selectedList,
      // selectedIdList,
      isEdit,
      processTypeOption,
      principalUserSelectId,
      memberUserSelectId,
      type,
      isShowSelectSupervise
    } = this.state;
    const {
      form,
      projectDetail,
      spinProps,
      superviseList,
      // existedOrgIds,
      // orgList
      activeKey
    } = this.props;
    const { getFieldsValue } = form;
    const {
      projectName,
      introduction,
      startTime,
      endTime,
      processType,
      projectType
    } = projectDetail;
    const time = [moment(startTime), moment(endTime)];

    const selectPricipalUserProps = {
      orgType: "county",
      onOk: this.handlePricipalFormDataChange,
      // selectSignature: principalUserSelectId || "",
      selectType: "user",
      appId: 70,
      appName: "督导"
    };

    const selectMemberUserProps = {
      orgType: "county",
      onOk: this.handleMemberFormDataChange,
      // selectSignature: memberUserSelectId || "",
      selectType: "user",
      appId: 70,
      appName: "督导"
    };

    const projectTypeProps = {
      keyName: "projectType",
      optionData: projectTypeData,
      isRequired: true,
      form,
      label: "项目类型",
      value: projectType,
      onChange: this.handleTypeChange,
      placeholder: "请选择项目类型"
    };

    const projectProcessProps = {
      keyName: "processType",
      optionData: processTypeOption,
      isRequired: true,
      form,
      label: "项目流程",
      value: processType,
      placeholder: "请选择项目流程"
    };

    const projectNameProps = {
      form,
      value: projectName,
      label: "项目名称",
      keyName: "projectName",
      maxLength: 100,
      suffix: `${(getFieldsValue().projectName &&
        getFieldsValue().projectName.length) ||
        0}/100`
    };

    const projectIntroProps = {
      form,
      value: introduction,
      keyName: "introduction",
      label: "项目介绍",
      maxLength: 1000,
      rows: 7
    };

    const planTimeProps = {
      form,
      value: isEdit ? time : null,
      label: "项目计划时间",
      keyName: "time",
      message: "请选择结束时间",
      format: "YYYY.MM.DD",
      myRules: [
        {
          type: "array",
          required: true,
          message: "请选择项目计划时间"
        }
      ]
    };

    const leadProps = {
      isRequired: true,
      form,
      label: "项目负责人",
      value: principalUserSelectId,
      keyName: "principalUserSelectId",
      showTabList: ["subordinateDept", "org"],
      ...selectPricipalUserProps
    };

    const memberProps = {
      isRequired: false,
      form,
      label: "项目成员",
      value: memberUserSelectId,
      keyName: "memberUserSelectId",
      showTabList: ["subordinateDept", "org"],
      ...selectMemberUserProps
    };

    return (
      <Container
        breStates={!0}
        version={2}
        defaultPadding
        footerParams={this.renderFooter()}
        isPathParams
      >
        <div className={styles["meeting-create-spin"]}>
          <Spin {...spinProps}>
            <div className={styles.root}>
              <FormCreate>
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeKey}
                  onChange={this.changeTab}
                >
                  <TabPane
                    tab={this.renderTabTitle(activeKey, "信息填写", "1")}
                    key="1"
                  >
                    <FormSelect {...projectTypeProps} />
                    <FormSelect {...projectProcessProps} />
                    <FormTitle {...projectNameProps} />
                    <FormTextArea {...projectIntroProps} />
                    <FormRangePicker {...planTimeProps} />
                  </TabPane>
                  <TabPane
                    tab={this.renderTabTitle(activeKey, "对象选择", "2")}
                    key="2"
                  >
                    <SelectUser {...leadProps} />
                    <SelectUser {...memberProps} />
                    <Item label="项目督查对象">
                      <>
                        <div>
                          <Button onClick={this.handleShowSupervise}>
                            选择
                          </Button>
                        </div>
                        {selectedNameList &&
                          selectedNameList.map(item => {
                            return <Tag style={{ marginTop: 3 }}>{item}</Tag>;
                          })}
                        {isShowSelectSupervise && (
                          <SelectSupervise
                            superviseList={superviseList}
                            onOk={this.handleSetSupervise}
                            onCancel={this.onCancel}
                          />
                        )}
                      </>
                    </Item>
                  </TabPane>
                </Tabs>
              </FormCreate>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default EditView;
